import Vue from 'vue'
import store from '../store/index'
import VueRouter from 'vue-router'
import Master from '../views/Master.vue'
import Index from '../views/index/Index.vue'
import Historia from '../views/nosotros/Historia.vue'
import Mision from '../views/nosotros/Mision.vue'
import Organigrama from '../views/investigacion/Organigrama.vue'
import Directorio from '../views/cuerposcolegiados/Directorio.vue'
import Gestion from '../views/nosotros/Gestion.vue'
import Consejo from '../views/investigacion/Consejo.vue'
import Comision from '../views/investigacion/Comision.vue'
import Administracion from '../views/administracion/Administracion.vue'
import EnesRes from '../views/enesresponde/EnesRes.vue'
import Igualdad from '../views/investigacion/Igualdad.vue'
import Contacto from '../views/contacto/Contacto.vue'

import EducacionContinua from '../views/educacioncontinua/EducacionContinua.vue'
import Lenguasuno from '../views/lenguas/Lenguas.vue'
import Lenguas from '../views/alumnos/Lengua.vue'
import Alumnado from '../views/alumnos/Alumnado.vue'
import Investigacion from '../views/investigacion/Investigacion.vue'
import Integrantes from '../views/comunidad/Integrantes.vue'
import Difusion from '../views/difusion/Difusion.vue'
import Calendario from '../views/investigacion/Calendario.vue'
import LAdmision from '../views/licenciatura/Admision.vue'
import Lmszc from '../views/licenciatura/Lmszc.vue'
import Icalendario from '../views/index/calendario/calendario.vue'
import INoticia from '../views/index/noticia/Noticia.vue'
import Politicas from '../views/politicas/politicas.vue'

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'Master',
        component: Master,
        props: true,
        meta: {
            requiresAuth: false,
        },
        children: [{
                path: '/index',
                name: 'index',
                component: Index,
                props: true
            }, {
                path: '/historia',
                name: 'historia',
                component: Historia,
            }, {
                path: '/mision',
                name: 'mision',
                component: Mision,
            }, {
                path: '/organigrama',
                name: 'organigrama',
                component: Organigrama,
            }, {
                path: '/directorio',
                name: 'directorio',
                component: Directorio,
            }, {
                path: '/gestion',
                name: 'gestion',
                component: Gestion,
            }, {
                path: '/consejo_tecnico',
                name: 'consejo',
                component: Consejo,
            }, {
                path: '/comision',
                name: 'comision',
                component: Comision,
            }, {
                path: '/administracion',
                name: 'administracion',
                component: Administracion,
            }, {
                path: '/enes-responde',
                name: 'enesresponde',
                component: EnesRes,
            }, {
                path: '/igualdad',
                name: 'igualdad',
                component: Igualdad,
            }, {
                path: '/contacto',
                name: 'contacto',
                component: Contacto,
            }, {
                path: '/lmszc/:id',
                name: 'lmszc',
                component: Lmszc,
                props: true,

            }, {
                path: '/ladmision',
                name: 'ladmision',
                component: LAdmision,
                props: true
            }, {
                path: '/educacioncontinua',
                name: 'educacioncontinua',
                component: EducacionContinua,
            }, {
                path: '/lenguas',
                name: 'lenguasuno',
                component: Lenguasuno,
            }, {
                path: '/alumnado',
                name: 'alumnado',
                component: Alumnado,
            }, {
                path: '/investigacion',
                name: 'investigacion',
                component: Investigacion,
            }, {
                path: '/integrantes',
                name: 'integrantes',
                component: Integrantes,
            }, {
                path: '/difusion',
                name: 'difusion',
                component: Difusion,
            }, {
                path: '/calendario',
                name: 'calendario',
                component: Calendario,
            }, {
                path: '/lenguas-1',
                name: 'lenguas',
                component: Lenguas,
            }, {
                path: '/icalendario',
                name: 'icalendario',
                component: Icalendario,

            }, {
                path: '/inoticia',
                name: 'inoticia',
                component: INoticia,
                props: true,
            },
            {
                path: '/politica',
                name: 'politica',
                component: Politicas,
                props: true,
            },

        ]
    },
    /*{
    	path: '/AdminRoot/',
    	name : 'AdminRoot',
    	component : Principal,
    	props:true,
    	meta : {
    		requiresAuth : true
    	},
    	children : [
    		{
    			path:'/permisos',
    			name:'permisos',
    			component:Permisos,
    			props:true
    		},
    		{
    			path:'/menus',
    			name:'menus',
    			component:Menus,
    			props:true
    		}
    	]
    },*/
]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            next();
            return;
        }
        next('/');
        console.log('debes iniciar session');
    } else {
        next();
    }
});

export default router